import React, { Component } from 'react';
import SmartAd from '../../../components/ads/smart-ad';

class AdUIService {
  putEvery(items, AdComponent, sinceI = 2, every = 10, compProps = {}) {
    return items.map((item, i) => {
      return (i - sinceI) % every === 0 ? [<SmartAd { ...compProps } key={`ad-banner-${i}`} />, item] : item
    });
  }
}

const adUIService = new AdUIService();
export default adUIService;